// Author: Kevin Thomas : XKO
// Date: 02/11/04
// JOB 22124

// This file contains barcode check-digit javascript functions for WModulo10

function ccd_WModulo10(strCode) {
  var i, blnMult, intTot, intCharVal, chkCheck, intLen;

  intTot = 0;

  intLen = strCode.length;
  var mult = false;
  if (intLen % 2 == 1) mult = true;
  else mult = false;

  for (i = 0; i < intLen; i++) {
    intCharVal = strCode.charCodeAt(i) - "0".charCodeAt(0);
    if (mult) intTot += 3 * intCharVal;
    else intTot += intCharVal;

    mult = !mult;
  }

  intCharVal = 10 - (intTot % 10);

  if (intCharVal == 10) intCharVal = 0;

  chkCheck = intCharVal.toString();
  return chkCheck;
}
export default ccd_WModulo10;
